// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  display: flex;
  flex-direction: column;
  width: 100%;

  &.profile-tile-info-main {
    @media ${(props) => props.theme.mediaQuery.desktop} {
      margin-left: 0px;
    }
  }
  .profile-heading {
    margin-left: 4px;
    display: flex;
    align-items: center;
    .profile-heading-left {
      display: flex;
      align-items: center;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      justify-content: space-between;
    }
  }
  .profile-status-logo {
    height: 22px;
    width: 22px;
    align-self: flex-start;
    display: flex;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 20px;
      width: 20px;
    }
  }
  .my-profile-heading {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    text-transform: uppercase;
    color: ${(props) => props.theme.colorPalette.gray[900]};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-weight: 700;
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    }
  }
  .profile-view-all {
    text-decoration: underline;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    line-height: 22px;
    margin-right: 19px;
  }

  .earn-tile-main {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    display: flex;
    justify-content: space-between;
  }

  .my-profile-edit-link {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    bottom: 0;
  }

  .cardDetailsWrapper {
    display: flex;
    padding-top: 12px;
    img {
      border: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      width: 50px;
      height: 31px;
    }
  }
  .cardDescriptionWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .section-heading {
    display: flex;
    justify-content: space-between;
  }
  .venmo-tile {
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }
  .cardExpiryWrapper {
    color: ${(props) => props.theme.colorPalette.gray[700]};
  }
  .recaptcha {
    -webkit-transform: scale(0.6);
    -ms-transform: scale(0.6);
    -moz-transform: scale(0.6);
    transform: scale(0.6);
    position: relative;
    left: -60px;
  }
  & .giftcardTile__wrapper {
    display: flex;
    align-items: flex-end;
  }
  & .input-fields-wrapper {
    height: auto;
  }
  & .TextBox__error {
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }
  & .TextBox__label {
    display: none;
    height: 100%;
    min-height: ${(props) => (props.card && props.card.ccType === 'VENMO' ? '173px' : '')};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED}
      ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG}
        ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }
  .cardEndingSpace {
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .check-balance {
    text-decoration: underline;
  }
  .card-number-image,
  .balance-action-container {
    display: flex;
    justify-content: space-between;
  }
  .card-number-image {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .expiry-card-number-container {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .tileWrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 0;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    min-height: 163px;
    border-bottom: 0;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: ${(props) => props.theme.colors.WHITE};
  }

  .edit-link-div {
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    position: absolute;
    margin-top: -33px;
  }
  .edit-link-card,
  .check-balance {
    font-weight: ${(props) => props.theme.fonts.fontWeight.medium};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
  }
  .card-expiry,
  .card-number {
    color: ${(props) => props.theme.colorPalette.gray[800]};
  }
  .image-text-container {
    height: 135px;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &.profile-tile-carousel-new {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    width: 100%;
    flex-direction: column;
    .credit-card-new {
      margin: 8px;
    }
    .slick-slider {
      padding: 0;
    }
    .slick-dots {
      justify-content: flex-start;
      position: relative;
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_1};
    }
    .slick-dots ul {
      margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
    .slick-dots li {
      margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0 0;
      width: 40px;
      height: 4px;
    }
    .slick-dots li button {
      width: 40px;
      height: 4px;
    }
    .slick-dots li button:before {
      width: 40px;
      height: 4px;
      border-radius: 0;
      background: #b0b0b0;
    }
    .slick-dots li.slick-active button:before {
      background: ${(props) => props.theme.colorPalette.blue[900]};
    }
  }
  .text-overflow-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export default styles;
